<template>
	<v-dialog
		v-model="showDialog"
		max-width="800px"
		:fullscreen="$vuetify.breakpoint.mdAndDown ? true : false"
		:transition="$vuetify.breakpoint.mdAndDown ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.mdAndDown">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">アラート詳細</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<!-- ここから書類不揃い -->
			<v-sheet v-if="alert_type == '書類不揃い'" class="pa-2" elevation="0">
				<h6 class="text-body-1 font-weight-bold">
					{{ alert_type }}
				</h6>
				<p class="mt-2">
					<!-- TODO:必要書類表示 -->
					必要書類：図面、製造指示書
				</p>
				<table width="100%" class="mt-4 show-dialog-table">
					<tbody>
						<tr>
							<th width="100%" class="font-weight-bold">現状ファイル</th>
						</tr>
						<!-- <tr v-for="file in matter.attached_files" :key="file.id">
							<td width="100%">
								<v-row no-gutters justify="space-between" align="center">
									<div> TODO: タグ名とファイル名</div>
									<v-btn color="secondary" @click="openFileDialog(file)" icon
										><v-icon>mdi-pencil</v-icon></v-btn
									>
								</v-row>
							</td>
						</tr> -->
					</tbody>
				</table>
				<v-btn color="secondary" class="mt-4 font-weight-bold" @click="$refs.uploadFile.click()">
					<v-icon class="mr-2">mdi-paperclip-plus</v-icon>
					ファイルを添付する
					<input type="file" class="d-none" ref="uploadFile" @change="addFiles($event)" multiple />
				</v-btn>
			</v-sheet>

			<!-- ここからそれ以外 -->
			<v-sheet v-else class="pa-2" elevation="0">
				<v-row no-gutters justify="space-between" align="center">
					<h6 class="text-body-1 font-weight-bold">
						{{ alert_type }}
					</h6>
					<v-btn color="secondary" @click="submitForm">
						<v-icon class="mr-1">mdi-save-outline</v-icon>
						保存
					</v-btn>
				</v-row>

				<table width="100%" class="mt-4 show-dialog-table show-dialog-table--form">
					<!-- TODO valueをサンプルデータから変更 -->
					<tbody v-if="alert_type == '承認予定日超過'">
						<ShowDetailRecord
							:columnName="'案件名'"
							:value="matter.name"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
						/>
						<ShowDetailRecord
							:columnName="'現在の承認予定日'"
							:value="'2023/05/03'"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
						/>
						<ShowDetailRecord :columnName="'新規承認予定日'">
							<template v-slot:value>
								<v-menu
									close-on-content-click
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											background-color="white"
											outlined
											dense
											readonly
											hide-details
											v-bind="attrs"
											v-on="on"
										/>
									</template>
									<v-date-picker no-title scrollable locale="ja" />
								</v-menu>
							</template>
						</ShowDetailRecord>
					</tbody>
					<tbody v-if="alert_type == '出荷日間近納入先未入力'">
						<ShowDetailRecord
							:columnName="'案件名'"
							:value="matter.name"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
						/>
						<ShowDetailRecord :columnName="'納入先名'">
							<template v-slot:value
								><v-text-field
									v-model="newMatter.delivery_company_name"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納入先郵便番号'">
							<template v-slot:value
								><v-text-field
									v-model="newMatter.delivery_zipcode"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納入先都道府県'">
							<template v-slot:value
								><v-text-field
									v-model="newMatter.delivery_prefecture"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納入先市区町村'">
							<template v-slot:value
								><v-text-field
									v-model="newMatter.delivery_city"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納入先住所'">
							<template v-slot:value
								><v-text-field
									v-model="newMatter.delivery_address"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納入先担当者'">
							<template v-slot:value
								><v-text-field
									v-model="newMatter.delivery_person_name"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納入先電話番号'">
							<template v-slot:value
								><v-text-field
									v-model="newMatter.delivery_phone"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
					</tbody>
					<tbody v-if="alert_type == '納期間近未受注'">
						<ShowDetailRecord
							:columnName="'案件名'"
							:value="matter.name"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
						/>
						<ShowDetailRecord
							:columnName="'現状見込み納期'"
							:value="common.formatDate(matter.quotation_deadline)"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
						/>
						<ShowDetailRecord :columnName="'新規見込み納期'">
							<template v-slot:value>
								<v-menu
									close-on-content-click
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="newMatter.quotation_deadline"
											background-color="white"
											outlined
											dense
											readonly
											hide-details
											v-bind="attrs"
											v-on="on"
										/>
									</template>
									<v-date-picker
										v-model="newMatter.quotation_deadline"
										no-title
										scrollable
										locale="ja"
									/>
								</v-menu>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord
							:columnName="'現状確度'"
							:value="matter.situation_i18n"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
						/>
						<ShowDetailRecord :columnName="'新規確度'">
							<template v-slot:value
								><v-select
									v-model="newMatter.situation"
									:items="situations"
									item-text="name"
									item-value="id"
									background-color="white"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'失注'">
							<template v-slot:value
								><v-checkbox
									v-model="newMatter.contract_flag"
									:value="false"
									hide-details
									label="失注"
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'失注理由'">
							<template v-slot:value
								><v-text-field
									v-model="newMatter.lost_reason"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'受注した競合'">
							<template v-slot:value
								><v-text-field
									v-model="newMatter.lost_to"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'競合受注額'">
							<template v-slot:value
								><v-text-field
									v-model="newMatter.lost_amount"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-sheet>
		</v-card>
		<FileShowDialog :file="selectedFile" :dialog.sync="fileDialog" authority_flag />
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import FileShowDialog from "../../shared/FileShowDialog.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		id: {
			type: Number,
			required: false,
			default: null,
		},
		alert_type: {
			type: null,
			required: false,
			default: false,
		},
	},
	components: {
		ShowDetailRecord,
		FileShowDialog,
	},
	data() {
		return {
			matter: {},
			newMatter: {},
			situations: [],
			selectedFile: {},
			fileDialog: false,
			common,
			rules,
		}
	},
	methods: {
		fetchMatter(id) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/sales/alerts/${id}`
			axios
				.get(url, { headers })
				.then((res) => {
					this.matter = res.data.matter
					this.situations = res.data.situations
					// TODO alert_typeによる処理
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openFileDialog(file) {
			this.selectedFile = file
			this.fileDialog = true
		},
		submitForm() {
			// TODO
		},
		addFiles(e) {
			const files = e.target.files
			// TODO
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		id(newVal, oldVal) {
			if (newVal == oldVal) return
			this.fetchMatter(newVal)
		},
		deep: true,
	},
}
</script>